module.exports = __webpack_public_path__ + "img/dizzy_bar.a833b22b.svg";